import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode'; // この構文で正しい

const AuthRoute = ({ children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');

    if (!token || !isTokenValid(token)) {
      console.warn('Invalid or expired token. Redirecting to login.');
      navigate('/'); // トークンが無効または期限切れの場合、ログインページへリダイレクト
    }
  }, [navigate]);

  const isTokenValid = (token) => {
    try {
      const decoded = jwtDecode(token);
      const currentTime = Math.floor(Date.now() / 1000); // 現在の時間 (秒単位)
      return decoded.exp && decoded.exp > currentTime;
    } catch (error) {
      console.error('Error decoding token:', error); // エラーをログに記録
      return false;
    }
  };

  return children;
};

export default AuthRoute;
